import { Component, OnInit } from '@angular/core';
import { AuthService } from '../app-services/auth.service';
import * as moment from 'moment/moment';
import { MatDialog } from '@angular/material';
import { RegisterComponent } from '../register/register.component';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.css']
})
export class LandingpageComponent implements OnInit {

  // register form feedback
  public emailErrors;
  public passwordErrors;
  public nameErrors;

  /**
   * Chart Array Details
   */
  public chartArray = [];
  public chartLabels = [];
  public chartData = [];
  public lineChartType: String = 'line';
  public lineChartLegend: Boolean = false;
  public lineChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false
  };

  /*
  *  Goal engagement
  */
  public goalName;
  public goalAmount;
  public amountAlreadySaved;
  public yearsUntilGoal;
  public amountToSaveInvestMonthly;
  public retireMonthlyAmountToLiveOn;
  public displayInputArea = true;


  constructor(private authService: AuthService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  public nextSlide(event) {

    // find which slide we are on
    let nextSlide = 0;
    const parentSlide = event.target.closest('.parent-tile');
    const children = event.target.closest('.parent-tile').children;

    for (var i = 0; i < children.length; i++) {
      if (children[i].classList.contains('viewable')) {
        nextSlide = i + 1;
      }
    }

    // hide the clicked on side
    children[nextSlide - 1].classList.add('hidden-slide');

    // check if we're on the last slide or not
    if (nextSlide < children.length) {
      // move to the next slide
      children[nextSlide].classList.remove('hidden-slide');
      children[nextSlide].classList.add('viewable');
    } else {
      // we're on the last slide we should display the results
      if (parentSlide.classList.contains('retire-early-slides')) {
        this.investmentCalculation('retire');
        this.goalName = 'Retire Early/Financial Freedom';
      } else if (parentSlide.classList.contains('millionaire-slides')) {
        this.investmentCalculation('million');
        this.goalName = 'Become A Millionaire';
      } else if (parentSlide.classList.contains('save-slides')) {
        this.goalName = 'New Car or House';
        this.savingsCalculation();
      }
    }
  }


  public savingsCalculation() {

    const numMonths = this.yearsUntilGoal * 12;
    const amountStillLeftToSave = this.goalAmount - this.amountAlreadySaved;
    this.amountToSaveInvestMonthly = Math.round(amountStillLeftToSave / numMonths * 100) / 100;

    this.calculateChart(numMonths, this.amountAlreadySaved, 'savings');
  }


  public calculateChart(numMonths, startAmount, type) {
    const chartData = [];
    const chartLabels = [];
    const interest = 1.08;
    let numMonthsOrYears;
    let timeScale;

    // get array of months or years(if investment)
    if (type === 'savings') {
      numMonthsOrYears = numMonths;
      timeScale = 'month';
    } else {
      numMonthsOrYears = numMonths / 12;
      timeScale = 'year';
    }

    for (let i = 0; i < (numMonthsOrYears + 1); i++) {
      chartLabels.push(moment().add(i, timeScale).format('MMMM YYYY'));
    }

    // start with the amount saved so far
    chartData.push(startAmount);

    if (type === 'savings') {

      for (let i = 0; i < numMonths; i++) {

        chartData.push((Math.round(chartData[i] * 100) / 100) + this.amountToSaveInvestMonthly);
      }
    } else if (type === 'investment') {

      const numYears = numMonths / 12;
      const yearlyContributions = this.amountToSaveInvestMonthly * 12;

      for (let i = 0; i < numYears; i++) {
        chartData.push((Math.round((chartData[i] + yearlyContributions) * interest) * 100) / 100);
      }
    }

    this.displayInputArea = false;
    this.chartArray = [{ chartData, chartLabels }];
  }



  public restartCalculations() {
    this.goalAmount = null;
    this.amountAlreadySaved = null;
    this.yearsUntilGoal = null;
    this.amountToSaveInvestMonthly = null;
    this.retireMonthlyAmountToLiveOn = null;

    this.displayInputArea = true;
  }


  public investmentCalculation(calcType) {

    // multiply monthlyRetirementSalary * 12 * 25 to calculate 4% safe withdraw rate
    const totalAmountNeededForRetirement = this.retireMonthlyAmountToLiveOn * 12 * 25;


    const interestRate = 1.08;
    let denomination1 = 1;
    let count1 = 0;

    while (count1 < this.yearsUntilGoal) {
      denomination1 = denomination1 * interestRate;
      count1 = count1 + 1;
    }

    const savingFutureValue = this.amountAlreadySaved * denomination1;

    if (calcType === 'retire') {
      var savingsGap = totalAmountNeededForRetirement - savingFutureValue;
      this.goalAmount = totalAmountNeededForRetirement;
    } else {
      var savingsGap = 1000000 - savingFutureValue;
      this.goalAmount = 1000000;
    }

    let count2 = 0;
    const intRate2 = 0.08 / 12;
    const numMonths = this.yearsUntilGoal * 12;
    const factor2 = 1 + intRate2;
    let denomination2 = 1;

    while (count2 < numMonths) {
      denomination2 = denomination2 * factor2;
      count2 = count2 + 1;
    }

    this.amountToSaveInvestMonthly = denomination2 - 1;
    this.amountToSaveInvestMonthly = intRate2 / this.amountToSaveInvestMonthly;
    this.amountToSaveInvestMonthly = this.amountToSaveInvestMonthly * savingsGap;

    // update the chart
    this.calculateChart(numMonths, this.amountAlreadySaved, 'investment');
  }



  public registerForm(value) {

      this.emailErrors = '';
      this.passwordErrors = '';
      this.nameErrors = '';

      this.authService.register(value).subscribe(res => {
        // nothing to do here!
        this.authService.setTokenAndForward(res);
      },
        error => {

          if (error.status === 403) {

          } else if (error.status === 422) {
            if (error.json().error.errors.name) {
              this.nameErrors = error.json().error.errors.name[0];
            }
            if (error.json().error.errors.email) {
              this.emailErrors = error.json().error.errors.email[0];
            }
            if (error.json().error.errors.password) {
              this.passwordErrors = error.json().error.errors.password[0];
            }
          }
        });
  }



  openRegister(): void {
    const dialogRef = this.dialog.open(RegisterComponent, {
      data: {
        goalName: this.goalName,
        goalAmount: this.goalAmount,
        yearsUntilGoal: this.yearsUntilGoal,
        netWorthRowName: 'Millionaire Investment Account',
        netWorthRowAmount: this.amountAlreadySaved,
        budgetRowName: this.goalName,
        budgetRowAmount: this.amountToSaveInvestMonthly,
        localDate: moment().format('YYYY-MM-DD HH:mm:ss')
      }
    });
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/landingpage/landingpage.component.ts